import { cancelOrder, refundOrder, createOrder, settlement } from '@/apis/order';
import router from '@/router';

export default {
  data:()=>({
    timerOut: null,
  }),
  methods: {
    // 取消订单
    toCancleOrder(order_no, needBack) {
      cancelOrder({
        order_no
      }).then(()=>{
        this.$useMessage({ type: 'success', message: '取消订单成功'});
        this.timerOut = needBack && setTimeout(()=>{
          this.$router.go(-1);
        }, 2000)

      })
    },
    // 生成订单
    toCreateOrder(orderInfo){
      createOrder(orderInfo).then(({result})=>{
        // 生成订单
        this.$store.commit( 'changeShopCarCount', result.shop_cart_count);
        this.$useMessage({ type: 'success', message: '订单提交成功' });
        this.toPay(result.order_no);
        // setTimeout(()=>{
          // this.$router.push('/orders');
        // }, 2000);
      })
    },
    // 立即购买(确认订单)
    buyNow(orderList, count){
      let list = null;
      if(count){
        list = orderList.map(item => ({
          ...item,
          count: count * 1,
          image: item.images ? item.images[0] : item.image
        }))
      }
      localStorage['orderList'] = JSON.stringify( count ? list : orderList);
      this.$router.push('/orders/check');
    },
    // 付款
    toPay(order_no){
      settlement({
        order_no,
        trade_type: this.runEnv,
      }).then(({ result }) => {
        if(this.runEnv !== "pc") this.wxSetFun(result);
        else{
          sessionStorage['payInfo'] = JSON.stringify(result);
          this.$router.push({ name: 'order-pay', query: { order_no } });  
        }
      })
    },
    // 退款
    toRefundOrder(order_no, refund_cause, needBack) {
      refundOrder({
        order_no,
        refund_cause,
      }).then(()=>{
        this.$useMessage({ type: 'success', message: '已发送退款请求,请等待客服处理'});
        this.timerOut = needBack && setTimeout(()=>{
          this.$router.go(-1);
        }, 2000)
      })
    },
    // 位置支付环境判断
    wxSetFun:function (result) {
      if( this.runEnv === "jsapi" ){
        // 如果是微信浏览器支付
        if (typeof WeixinJSBridge == "undefined"){
          if( document.addEventListener ){
            document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
          }else if (document.attachEvent){
            document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
            document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
          }
        }else{
          this.onBridgeReady(result);
        }
      } else {
        // 如果是普通浏览器支付
        if(!result.mweb_url){
          this.$toast.fail('H5支付暂未开通，请在PC端或微信内支付');
        } else {
          // console.log(22222222);
          window.location.href = result.mweb_url;
        }
      }
    },     
    // 调起微信支付
    onBridgeReady(result) {
      // WeixinJSBridge 微信环境才会有
      window.WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
          "appId":result.appId,
          "timeStamp":result.timeStamp,
          "nonceStr":result.nonceStr,
          "package":result.package,
          "signType":result.signType,
          "paySign":result.paySign
        },(res) => {
          if(res.err_msg == "get_brand_wcpay_request:ok" ){
            this.$toast.success('支付成功');
            this.$toast.loading({
              mask: true,
              message: '正在检查支付状态...',
              duration: 0
            });
            this.$http({
              url:'wechat/pay_query',
              method:'GET',
              params:{
                order_no: this.curOrder
              }
            }).then(() => {
              this.$router.push({ path:'/pay/result', query:{ type: 1 }})
            }).catch(err => {
              this.$router.push({ path:'/pay/result', query:{ type: 2 }})
              this.$useMessage({ type: 'error', message: JSON.parse(err)});
            })
          } else {
            this.$useMessage({ type: 'error', message: '支付失败'});
            this.$router.push({path: '/pay/result', query: { type: 2 }})
          }
        }
      );
    },
  },
  destroy() {
    this.timerOut && clearTimeout(this.timerOut);
  }
}